import { Model } from 'pinia-orm';
import Job from './Job';

export default class Campaign extends Model {

    static get entity() {
        return 'campaigns'
    }

    static fields() {
        return {
            id: this.uid(),
            locale: this.string(null),
            date_start: this.attr(null),
            date_end: this.attr(null),
            channels: this.attr([]),
            channel_ids: this.attr([]),
            suggestions: this.attr([]),
            price: this.number(0),
            channels_total_price: this.number(0),
            duration: this.number(null),
            paid: this.boolean(false),
            active: this.boolean(true),
            published: this.boolean(true),
            online: this.boolean(true),
            archived: this.boolean(true),
            draft: this.boolean(true),
            paid_at: this.attr(''),
            submitted_at: this.attr(''),
            fetched_at: this.attr(''),
            status: this.string(''),
            step: this.string(''),
            job_id: this.number(null),
            stats: this.attr({}),
            processing: this.attr(false),
            has_only_intern_channels: this.attr(false),
            country_code: this.attr(''),
            created_at: this.string(''),
            updated_at: this.string(''),
            campaign_package_id: this.attr(null),
            limited: this.boolean(false),

            // settings
            job_title: this.string(''),
            job_description: this.string(''),
            job_requirements: this.string(''),
            sector: this.attr(''),
            job_level: this.attr(''),
            regions: this.attr([]),
            educations: this.attr([]),
            job_profiles: this.attr([]),
            date_start_preferred: this.attr(null),
            job_url: this.string(null),


            //relationships
            application_count: this.number(0),
            job: this.belongsTo(Job, 'job_id')
        }
    }
}
